<template>
    <div id="app">
        <Loading></Loading>
        <!-- <Loading></Loading>
    <NavBar></NavBar>
    <div class="nj-views">
        <div class="nj-view-container">
            <router-view/>
        </div>
    </div>
    <div class="nj-version">{{ version }}</div> -->
        <router-view></router-view>
        <div class="nj-version">{{ version }}</div>
    </div>
</template>
<script>
import Loading from "./components/Loading.vue"
import Environment from "./services/Environment"

export default {
    components: {
        Loading
    },
    data() {
        return {
            version: Environment.version
        }
    },
    mounted() {

    }
}
</script>
<style lang="scss">
$body-font-size: 12px !important;
$family-primary: "Open Sans", sans-serif;
$red: #ea4335;
$green: #03823f;
$yellow: #f8ed62;
$text: #666666;
$grey-dark: #666666;
$cyan: #0077b6;
$blue: #0077b6;

#app {
    height: 100%;
}

.nj-views {
    --space: 70px;
    padding: var(--space) 12px 12px 12px;
    background-color: #f8f8f8;
    min-height: 100%;
}

.nj-view-container {
    max-width: var(--max-width);
    margin: 0 auto;
}

.nj-version {
    background-color: var(--nj-color-green) !important;
    color: #fff;
    font-size: 10px;
    padding: 6px;
    position: fixed;
    z-index: 11;
    bottom: 6px;
    right: 6px;
    border-radius: 4px;
}

@import "~bulma";
@import "~buefy/src/scss/buefy";
@import './css/styles.css';
</style>
